import React from 'react';

const PageLoading = () => (
    <div>
        <p>Loading...</p>
    </div>
);

export default PageLoading;
